import React, { Component } from 'react'
import { Badge } from 'reactstrap'

class LeaveLegend extends Component {

  state = {
    colors: [ "primary", "success", "danger", "warning", "info" ],
    shifted: false
  }

  generateList = () => {
    if(!(this.props.list[0] === undefined)) {
      var leaveArray = [...this.props.list]
      leaveArray.shift()
      const List = leaveArray.map((line, index) => {
        return (
          <p key={index}><Badge color={this.state.colors[line.order - 1]} pill >{line.order}</Badge>{' '}{line.leave}</p>
        )
      })
      return List
    }
    return null
  }

  render () {
    return (
      <div style={legendStyle}>
        <h2>Faculty on Leave:</h2>
        {this.generateList()}
      </div>
    )
  }
}

const legendStyle = {
  border: '2px solid #000000',
  borderRadius: '8px',
  margin: '0px 0px 16px 0px',
  padding: '10px 10px',
  fontFamily: 'Avenir'
}

export default LeaveLegend
